import { Order, PayOrderRequest, PayOrderResponse } from '@/types/api/order';
import { authenticatedClient } from '@/utils/shared/axios';

export default {
  get: async (orderId: string) => {
    const response = await authenticatedClient.get(`/orders/${orderId}`);
    return response.data;
  },

  list: async (params: object) => {
    const response = await authenticatedClient.get<Order[]>(`/orders`, { params });
    return response.data;
  },

  cancel: async (orderId: string): Promise<void> => {
    const response = await authenticatedClient.post(`/orders/${orderId}/cancel`);
    return response.data;
  },

  deliver: async (orderId: string) => {
    await authenticatedClient.post(`/orders/${orderId}/deliver`);
  },

  pay: async (data: { orderId: string } & PayOrderRequest) => {
    const { orderId, ...body } = data;
    const response = await authenticatedClient.post<PayOrderResponse>(`/orders/${orderId}/pay`, body);
    return response.data;
  },
};
